var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseRemoteService } from "../core/BaseRemoteService";
import { paramsToSearchString } from "../../utils/urlHelper";
export class EmailService extends BaseRemoteService {
    constructor() {
        super(...arguments);
        this._mailFolderId = undefined;
    }
    getAll(params = {}) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/users/${(_a = this.authService) === null || _a === void 0 ? void 0 : _a.getUpn()}/emails${paramsToSearchString(Object.assign(Object.assign({}, params), { mailFolderId: this._mailFolderId }))}`;
            const response = yield this.getRequest(url);
            if (!response.data.length && ((_b = response.extendedProperties) === null || _b === void 0 ? void 0 : _b.noMailFolder)) {
                response.data = [
                    {
                        disabled: true,
                        subject: "It looks like you do not have a folder in Outlook with the name Complaints. " +
                            "Please make sure that you have created a mail folder with this exact name." +
                            " Emails that you move in to this folder will appear here in order to be attached to a case.",
                    },
                ];
            }
            if (!this._mailFolderId && ((_c = response.extendedProperties) === null || _c === void 0 ? void 0 : _c.mailFolderId)) {
                // a simple per-session cache of mailFolderId, to save some work on the server
                this._mailFolderId = (_d = response.extendedProperties) === null || _d === void 0 ? void 0 : _d.mailFolderId;
            }
            return response;
        });
    }
}
